/* eslint-disable arrow-parens */
import {Game} from './Game';

function init() {
	const game = new Game();

	let fpsInterval;
	// eslint-disable-next-line no-unused-vars
	let startTime;
	let now;
	let then;
	let	elapsed;

	function animate() {
		// request another frame
		requestAnimationFrame(animate);

		// calc elapsed time since last loop
		now = Date.now();
		elapsed = now - then;

		// if enough time has elapsed, draw the next frame
		if (elapsed > fpsInterval) {
			// Get ready for next frame by setting then=now, but also adjust for your
			// specified fpsInterval not being a multiple of RAF's interval (16.7ms)
			then = now - elapsed % fpsInterval;

			// Put your drawing code here
			if (game.state === 'play') {
				// clear canvas
				// clearCanvas();
				// draw game animation
				game.drawGame(fpsInterval);
			}
		}
	}

	function startAnimating(fps) {
		fpsInterval = 1000 / fps;
		then = Date.now();
		startTime = then;
		animate();
	}

	setTimeout(() => {
		game.drawGame(16);
	}, 10);

	startAnimating(game.fps);
	window.addEventListener('resize', game.resize);
}

export default {
	init,
};
